"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * React utility methods
 */
class ReactHelper {
  /**
   * Render a component.
   * 
   * @param {ReactComponent|ReactNode|DOMNode} Component
   * @param {Object} props optional
   * @return {ReactNode}
   */
  static render(Component) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if ( /*#__PURE__*/_react.default.isValidElement(Component)) return Component;else return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, { ...props
    });
  }

}

var _default = ReactHelper;
exports.default = _default;